module.exports = __webpack_public_path__ + "img/11.3bd063ae.jpg";